import { StyleSheet } from 'react-native';
import { themes } from 'src/theme/theme';

export const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: themes.light.brand_blue[7],
    paddingVertical: 12,
    paddingHorizontal: 16,
  },
  text: {
    flex: 1,
    flexWrap: 'wrap', // Allow text to wrap to next line
    marginRight: 16,
  },
  button: {
    width: 100,
    height: 36,
    justifyContent: 'center',
    alignItems: 'center',
  },
});

export const desktopStyles = StyleSheet.create({
  container: {
    borderRadius: 8,
    marginHorizontal: 16,
    marginTop: 8,
    marginBottom: 4,
  },
});
